// Environment-specific configuration
const isDevelopment = process.env.NODE_ENV === 'development';

// API Configuration
const API_HOST = process.env.REACT_APP_API_HOST || (isDevelopment ? 'http://localhost:3001' : 'https://varos.insomnialabs.com');

export const config = {
  api: {
    baseUrl: `${API_HOST}/api`,
    auth: {
      google: `${API_HOST}/api/auth/google`,
    }
  },
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  }
};

export default config; 